<template>
  <v-layout row wrap>
    <v-flex xs12>
      <SummaryTitle>Company</SummaryTitle>
    </v-flex>

    <v-flex xs12>
      <p class="summary--sidebar-title">{{company.name}}</p>
      <p v-if="company.phone" class="summary--sidebar-content">{{company.phone}}</p>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from 'vuex';

import SummaryTitle from '@/components/common/SummaryTitle.vue';

export default {
  components: {
    SummaryTitle,
  },
  computed: {
    ...mapState('Company', {
      company: state => state.company,
    }),
  },
};
</script>

<style lang="scss" scoped>
p {
  margin: 0;
}
</style>
